import { useState } from "react";
import { useNavigate } from "react-router-dom";

// 🔥 SMART AI
const generateFeedback = (answer) => {
  let score = 5;
  let feedback = "";

  if (!answer || answer.length < 10) {
    return {
      score: 2,
      feedback: "❌ Too short. Try explaining concepts clearly.",
    };
  }

  if (answer.toLowerCase().includes("example")) score += 2;
  if (answer.length > 50) score += 2;
  if (answer.toLowerCase().includes("because")) score += 1;
  if (answer.toLowerCase().includes("real world")) score += 1;

  if (score >= 8) {
    feedback = "🔥 Excellent answer! Strong clarity and depth.";
  } else if (score >= 6) {
    feedback = "👍 Good answer. Add examples for perfection.";
  } else {
    feedback = "⚠️ Basic answer. Try explaining with examples.";
  }

  return { score, feedback };
};

function Interview() {
  const questions = [
    "What is OOP?",
    "Explain polymorphism.",
    "What is a database?",
    "What is REST API?",
  ];

  const [current, setCurrent] = useState(0);
  const [answer, setAnswer] = useState("");
  const [feedback, setFeedback] = useState("");
  const [score, setScore] = useState(0);

  const navigate = useNavigate();

  // 🔥 HANDLE SUBMIT
  const handleSubmit = () => {
    if (!answer.trim()) {
      setFeedback("❌ Please enter an answer");
      return;
    }

    const result = generateFeedback(answer); // ✅ FIXED

    // 🔥 Save to leaderboard
    const existing = JSON.parse(localStorage.getItem("leaderboard")) || [];

    existing.push({
      score: result.score,
      date: new Date().toLocaleDateString(),
    });

    localStorage.setItem("leaderboard", JSON.stringify(existing));

    setFeedback(`${result.feedback} (Score: ${result.score}/10 ⭐)`);
    setScore((prev) => prev + result.score);

    localStorage.setItem("lastScore", result.score);
  };

  // 🔥 NEXT QUESTION
  const nextQuestion = () => {
    if (current === questions.length - 1) {
      navigate("/summary", {
        state: { score, total: questions.length },
      });
    } else {
      setCurrent(current + 1);
      setAnswer("");
      setFeedback("");
    }
  };

  return (
    <div style={styles.container}>
      <h2>AI Interview 🤖</h2>

      <h3>Score: {score} ⭐</h3>

      <div style={styles.card}>
        <h3>{questions[current]}</h3>

        <textarea
          placeholder="Type your answer..."
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          style={styles.textarea}
        />

        <button onClick={handleSubmit} style={styles.btn}>
          Submit Answer
        </button>

        <p>{feedback}</p>

        {feedback && (
          <button onClick={nextQuestion} style={styles.next}>
            {current === questions.length - 1
              ? "Finish Interview 🎯"
              : "Next Question ➡️"}
          </button>
        )}
      </div>
    </div>
  );
}

// 🔥 STYLES
const styles = {
  container: {
    padding: "20px",
    background: "#1e1e2f",
    minHeight: "100vh",
    color: "white",
  },

  card: {
    background: "rgba(255,255,255,0.1)",
    padding: "20px",
    borderRadius: "12px",
    maxWidth: "500px",
    margin: "auto",
    marginTop: "20px",
  },

  textarea: {
    width: "100%",
    height: "100px",
    marginTop: "10px",
    borderRadius: "8px",
    padding: "10px",
    border: "none",
  },

  btn: {
    marginTop: "10px",
    padding: "10px",
    background: "#00c6ff",
    border: "none",
    borderRadius: "6px",
    color: "white",
    cursor: "pointer",
  },

  next: {
    marginTop: "10px",
    padding: "10px",
    background: "#4CAF50",
    border: "none",
    borderRadius: "6px",
    color: "white",
    cursor: "pointer",
  },
};

export default Interview;